import React from 'react';
import Quote from '../Quote';
import './style.css'


export default function QuotesList({ quotes }) {
  const quoteElement = <Quote quote = {quotes.rand()} />
  return (
    <div className="article-list__div mx-auto">
      {quoteElement}
    </div>
  )
}

Array.prototype.rand = function() {
  return this[Math.floor(Math.random() * this.length)];
}



// WEBPACK FOOTER //
// ./src/components/QuotesList/index.js